(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    // Honeypot anti-spam: block submission if hidden field is filled
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.classList.contains('contact-form__form')) return;
    const honeypot = form.querySelector('[name="contact[website]"]');
    if (honeypot && honeypot.value.trim() !== '') {
      e.preventDefault();
      e.stopImmediatePropagation();
      // Show fake success to not alert the bot
      const successDiv = document.createElement('div');
      successDiv.className = 'contact-form__success';
      successDiv.textContent = 'Thank you! Your message has been sent.';
      form.prepend(successDiv);
      form.reset();
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
